import { Form, SidebarModal } from '@domain-group/suit-theme'

import Comment from '@components/Comment'
import Subscriber from '@components/Subscriber'

import type { CommentModel, SubscriberModel } from '@models/types'

interface ExistingConversationProps {
  filteredSubscribers: SubscriberModel[],
  filteredSubscribersCount: number,
  hasFilteredComments: boolean,
  lastComment: CommentModel,
}

const ExistingConversation = (props: ExistingConversationProps) => {
  const {
    filteredSubscribers,
    filteredSubscribersCount,
    hasFilteredComments,
    lastComment,
  } = props

  return (
    <>
      <Form.Field direction="column" label="Subscribers">
        {filteredSubscribers?.map(subscriber => (
          <Subscriber
            filteredSubscribersCount={filteredSubscribersCount}
            initSubscriber={subscriber}
            key={subscriber.id}
          />
        ))}
      </Form.Field>

      {hasFilteredComments && (
        <Form.Field direction="column" label="Latest Comment" marginTop="large">
          <Comment
            boxProps={{ marginTop: 'large' }}
            comment={lastComment}
            isLastComment
            key={lastComment?.id}
          />
        </Form.Field>
      )}

      <SidebarModal.Separator />
    </>
  )
}

export default ExistingConversation
